import { Typography } from "@mui/material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { FileUploader } from "react-drag-drop-files";
import "./styles/common.css";
import { imageUploader } from "./styles/commonStyles";
import { uploadImageToS3 } from "@command-center-app/services/util-api.service";
import { toast } from "react-toastify";
import { useState } from "react";

const GenericImageUploader = ({
  setFile,
  fullWidth = false,
  // @ts-ignore
  fileTypes = ["JPG", "PNG", "GIF", "JPEG", "SVG", "EPS", "AI", "PSD", "PDF", "TIFF", "BMP", "WEBP"],
  showInModal = false,
}: any) => {
  const fileAssetImage = "/assets/images/file-upload.png";
  const [loading, setLoading] = useState(false);

  const handleChange = async (image: any) => {
    setLoading(true);
    const formData = new FormData();
    formData.append("image", image);
    try {
      const response = await uploadImageToS3(formData);
      const data = response?.data;
      if (data?.error) {
        toast.error(data?.error ?? "Failed to upload image");
      } else if (data) {
        setFile?.({ url: data?.url, type: image.type });
      }
    } catch (err: any) {
      console.error(err);
      toast.error(err?.message || "Failed to upload image");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ height: showInModal ? "100%" : "auto" }}>
      <Box
        sx={{
          ...imageUploader.imageUploaderContainer,
          ...(fullWidth ? { width: "100%" } : {}),
          ...(showInModal
            ? {
                height: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }
            : {}),
        }}
      >
        <div style={imageUploader.fileUploadContainer}>
          <img
            src={fileAssetImage}
            alt={"assets"}
            style={imageUploader.imageStyle}
          />
          <FileUploader
            multiple={false}
            uploadedLabel=" "
            handleChange={handleChange}
            name="file"
            label={" "}
            classes="image-uploader"
            disabled={loading}
          />
          <div
            style={{
              marginTop: "-100px",
              ...(fullWidth && { textAlign: "center" }),
            }}
          >
            {showInModal ? (
              <>
                <Typography sx={imageUploader.uploaderTitleTextStyle}>
                  Start adding your files
                </Typography>
                <Typography
                  variant="body2"
                  style={imageUploader.uploaderDetailsTextStyle}
                >
                  Drag and drop files or <br /> upload from your computer
                </Typography>
              </>
            ) : (
              <Typography
                variant="body2"
                style={imageUploader.uploaderDetailsTextStyle}
              >
                Drag and drop files or upload from your computer
              </Typography>
            )}
            <Button
              style={{
                fontFamily: "inter-medium",
                ...(showInModal
                  ? { textAlign: "center" }
                  : { marginLeft: "50px" }),
              }}
              loading={loading}
            >
              <Typography sx={{ fontSize: "14px", textTransform: "none" }}>
                + Upload files
              </Typography>
            </Button>
          </div>
        </div>
      </Box>
      <div
        style={{ position: "absolute", zIndex: 1, width: "91%", top: "68px" }}
      ></div>
    </div>
  );
};

export default GenericImageUploader;
